module.exports = __webpack_public_path__ + "static/media/14UNEP14.0f28b2f4.jpg";